import React from 'react';
import { getUserLocation } from '../../../utils/locationService';

const LocationCard = ({ location, index, onViewDetails }) => {

  const handleGetDirections = async () => {
    if (location.comingSoon) return;
    
    // Proveravamo da li imamo koordinate
    const hasCoords = location.lat && location.lng;

    try {
      const userLocation = await getUserLocation();
      
      let mapsUrl;
      if (hasCoords) {
        // Ako imamo koordinate, koristimo ih za maksimalnu preciznost
        mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLocation.lat},${userLocation.lng}&destination=${location.lat},${location.lng}`;
      } else {
        // Fallback na adresu ako koordinate fale
        const townshipPart = location.township ? `${location.township}, ` : '';
        const destination = `${location.address}, ${townshipPart}${location.city}`;
        mapsUrl = `https://maps.google.com/maps?saddr=${userLocation.lat},${userLocation.lng}&daddr=${encodeURIComponent(destination)}`;
      }
      
      window.open(mapsUrl, '_blank');
    } catch (error) {
      // Ako ne možemo da dobijemo lokaciju korisnika, samo otvaramo destinaciju
      let mapsUrl;
      if (hasCoords) {
        mapsUrl = `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`;
      } else {
        const destination = `${location.address}, ${location.city}`;
        mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(destination)}`;
      }
      window.open(mapsUrl, '_blank');
    }
  };

  const handleCallLocation = () => {
    if (location.comingSoon || !location.phone) return;
    window.location.href = `tel:${location.phone.replace(/\s/g, '')}`;
  };

  return (
    <div className={`location-card ${location.comingSoon ? 'is-coming-soon' : ''}`}>
      {location.comingSoon && <div className="coming-soon-badge">USKORO</div>}
      
      <div className="location-image">
        <img src={location.image} alt={location.name} />
        {!location.comingSoon && (
          <div className="location-overlay">
            <button className="view-details-btn" onClick={() => onViewDetails(location)}>
              Pogledajte detalje
            </button>
          </div>
        )}
      </div>
      
      <div className="location-content">
        <h3>{location.name}</h3>
        
        <div className="location-details">
          <div className="detail">
            <div className="detail-icon-bg">📍</div>
            <span>{location.address}</span>
          </div>
          <div className="detail">
            <div className="detail-icon-bg">🕒</div>
            <span>{location.working_time}</span>
          </div>
          <div className="detail">
            <div className="detail-icon-bg">🚗</div>
            <span>{location.number_of_boxes === 1 ? '1 boks za pranje' : 
                  [2, 3, 4].includes(location.number_of_boxes) ?
                  `${location.number_of_boxes} boksa za pranje` : 
                  `${location.number_of_boxes} bokseva za pranje`}</span>
          </div>
        </div>
        
        <div className="location-actions">
          {!location.comingSoon ? (
            <button className="action-btn directions" onClick={handleGetDirections}>
              🗺️ Putanja
            </button>
          ) : (
            <button className="action-btn disabled-btn" disabled>
               USKORO DOSTUPNO
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationCard;